<template>
  <el-dialog
    width="1000px"
    title="批量同步商品"
    :visible.sync="props.isShowing"
    :before-close="changeIsShowing"
    @open="onSearch"
  >
    <!-- 选择是否发布 -->
    <div style="display: flex; gap: 12px">
      <div>确定将以下选中商品</div>
      <el-radio-group v-model="isPublish">
        <el-radio :label="1">同步为推荐商品并发布</el-radio>
        <el-radio :label="0">同步为推荐商品但不发布</el-radio>
      </el-radio-group>
    </div>

    <!-- 搜索词条 -->
    <!-- <div style="margin: 24px 0"> -->
    <el-form
      class="batch-sync-form"
      style="margin: 24px 0"
      size="mini"
      :inline="true"
      :model="form"
      label-width="auto"
    >
      <!-- 商品ID -->
      <el-form-item label="商品ID">
        <el-input v-model="form.goodsId" placeholder="请输入商品ID" />
      </el-form-item>
      <!-- 商品名称 -->
      <el-form-item label="商品名称">
        <el-input v-model="form.goodsName" placeholder="请输入商品名称" />
      </el-form-item>
      <!-- 搜索 -->
      <el-form-item>
        <el-button type="primary" @click="onSearch">搜索</el-button>
      </el-form-item>
    </el-form>
    <!-- </div> -->
    <div>
      <el-table
        v-loading="isLoading"
        border
        :data="datas"
        @selection-change="handleSelectionChange"
        row-key="id"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column prop="id" label="商品ID" width="80" />
        <el-table-column prop="name" label="商品名称" min-width="250" />
        <el-table-column prop="coverImgUrl" label="商品封面图" min-width="81">
          <template slot-scope="{ row }">
            <el-image
              v-if="row.coverImgUrl"
              style="width: 60px; min-height: 60px"
              :src="
                row.coverImgUrl.split(',')[0] ?? row.imageUrls.split(',')[0]
              "
              :preview-src-list="
                row.coverImgUrl.split(',') ?? row.imageUrls.split(',')[0]
              "
            />
          </template>
        </el-table-column>
        <el-table-column prop="backGoryName" label="商品类目" min-width="200" />
      </el-table>
      <el-pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :page-sizes="[10, 20, 30]"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      />
      <div
        style="
          margin-top: 24px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <el-button @click="changeIsShowing">取 消</el-button>
        <el-button
          type="primary"
          :loading="isBatchSync"
          @click="requestOfBatchSync"
          >确定</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, reactive, getCurrentInstance, onMounted } from "vue";

const app = getCurrentInstance().proxy;

const props = defineProps({
  isShowing: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["close", "batchSyncSuccess"]);

const form = reactive({
  goodsId: "",
  goodsName: "",
});

const isPublish = ref(0);
const isBatchSync = ref(false);

// 表格数据
const isLoading = ref(true);
const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);
const datas = ref([]);
const selectedItems = ref([]);

// 选中事件
const handleSelectionChange = (val) => {
  selectedItems.value = val;
};

// 每页条数改变
const handleSizeChange = (val) => {
  pageSize.value = val;
  requestOfNotProduct();
};

// 分页改变
const handleCurrentChange = (val) => {
  currentPage.value = val;
  requestOfNotProduct();
};

/**
 * 切换显示状态的函数
 *
 * @description 该函数用于触发关闭事件，通知父组件当前组件需要关闭
 *
 * @returns {void}
 */
const changeIsShowing = () => {
  emit("close");
};

/**
 * 批量同步商品数据请求函数
 * 该函数用于向服务器发送批量同步商品的请求，包含商品ID、发布状态和供应商ID等参数
 * @returns {void}
 */
const requestOfBatchSync = () => {
  if (!selectedItems.value.length) {
    app.$message.warning("请勾选商品后再试");
    return;
  }
  isBatchSync.value = true;
  const params = {
    goodsId: selectedItems.value.map((item) => item.id),
    publishState: isPublish.value,
    supplierId: JSON.parse(localStorage.userInfo || "{}").suppliersId,
  };

  app.$axios
    .post(app.$api.goodsmanage.trade_goods_sync_product, params)
    .then((res) => {
      // 处理响应结果
      if (res.code === 0) {
        app.$message.success("操作成功，请前往选品中心推荐商品列表查看");
        requestOfNotProduct();
        emit("batchSyncSuccess");
      }
      isBatchSync.value = false;
    });
};

/**
 * 搜索事件处理函数
 *
 * @description 执行搜索操作的回调函数，通常绑定到搜索按钮或输入框的事件上
 * @returns {void}
 */
const onSearch = () => {
  currentPage.value = 1;
  requestOfNotProduct();
};

/**
 * 请求非商品数据列表
 *
 * 该函数用于获取非商品数据的分页列表，通过API请求获取数据并更新页面状态
 *
 * @returns {Promise<void>} 无返回值，通过修改响应式变量来更新页面状态
 */
const requestOfNotProduct = async () => {
  // 设置加载状态为true，显示加载动画
  isLoading.value = true;

  app.$axios
    .get(app.$api.goodsmanage.trade_goods_not_product_page, {
      params: {
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        name: form.goodsName ?? "",
        id: form.goodsId ?? "",
      },
    })
    .then((res) => {
      // 处理响应结果
      if (res.code === 0) {
        // 请求成功，更新总数量和数据列表
        total.value = +res.data.total;
        datas.value = res.data.records;
      }
      // 无论请求成功与否，都关闭加载状态
      isLoading.value = false;
    });
};

onMounted(() => {
  // requestOfNotProduct();
});
</script>

<style lang="scss">
// .batch-sync-form {
//   .el-form--inline {
//     .el-form-item--mini {
//       .el-form-item__label-wrap {
//         margin-left: 0 !important;
//       }
//     }
//   }
// }
</style>
